<template>
  <div>
    <v-dialog v-model="internalDialog" max-width="500px" scrollable>
      <v-card class="pa-3" min-height="650px">
        <v-card-title>
          <v-row>
            <v-col cols="12" class="text-left pt-10">
              <h3><strong>เพิ่มรายการนัดหมาย</strong></h3>
            </v-col>
          </v-row>
        </v-card-title>
        <v-card-text>
          <v-row align="center">
              <v-col cols="12">
                <v-select
                  v-if="branch.length > 1"
                  v-model="formSelect.masBranchID"
                  :label="languageSelect === 0 ? 'สาขา *' : 'Branch *'"
                  dense
                  outlined
                  :item-text="languageSelect === 0 ? 'text' : 'textEn'"
                  :items="branch"
                  attach
                  :menu-props="{ bottom: true, offsetY: true }"
                  @change="selectBranch(), formSelect.group_Flow_Id = ''"
                ></v-select>
                <v-select
                  v-if="formSelect.masBranchID !== '' && formSelect.masBranchID !== null"
                  v-model="formSelect.group_Flow_Id"
                  :label="languageSelect === 0 ? 'ประเภทบริการ *' : 'Service *'"
                  dense
                  outlined
                  :item-text="languageSelect === 0 ? 'text' : 'textEn'"
                  :items="groupFlow"
                  attach
                  :menu-props="{ bottom: true, offsetY: true }"
                  @change="selectGroupFlow(), formSelect.flowId = ''"
                ></v-select>
                <v-select
                  v-if="formSelect.group_Flow_Id !== '' && formSelect.group_Flow_Id !== null"
                  v-model="formSelect.flowId"
                  :label="languageSelect === 0 ? 'แพ็คเกจ *' : 'Packages *'"
                  :item-text="languageSelect === 0 ? 'text' : 'textEn'"
                  dense
                  outlined
                  :items="DataFlow"
                  attach
                :menu-props="{ bottom: true, offsetY: true }"
                  @change="checkBranch(), checkTitleEmp()"
                >
            </v-select>
                <!-- <v-col cols="12" class="pt-0 pb-0" v-if="formSelect.masBranchID !== '' && formSelect.group_Flow_Id !== '' && formSelect.flowId !== ''">
                  <VuetifyMoney
                    v-model="depositPrice"
                    placeholder="จำนวนเงินมัดจำ"
                    dense
                    label="จำนวนเงินมัดจำ"
                    outlined
                    v-bind:options="options2"
                  />
                </v-col> -->
              <div class="mb-5" v-if="formSelect.masBranchID !== '' && formSelect.group_Flow_Id !== '' && formSelect.flowId !== ''">
                <v-item-group
                  v-model="selectedEmpList"
                  multiple
                >
                  <v-row>
                    <v-col
                      v-for="(emp,i) in dataEmpAll"
                      :key="i"
                      cols="6"
                      sm="6"
                      md="6"
                    >
                      <v-item :value="emp.empId" v-slot="{ active, toggle }">
                        <v-sheet
                          elevation="6"
                          class="pa-2"
                        >
                        <v-img
                          v-if="emp.empImge"
                          max-height="150"
                          max-width="250"
                          :src="emp.empImge"
                          @click="openDialogPreView(emp.picture[0].gallery)"
                        ></v-img>
                        <div
                          v-else
                          style="max-width: 250px; max-height: 150px; width: 100%; height: 100%; display: flex; justify-content: center; align-items: center; border: 1px dashed #ccc;"
                        >
                          <v-icon
                            style="font-size: 96px;"
                          >
                          mdi-image-multiple
                          </v-icon>
                        </div>
                          <div class="mt-2 d-flex align-center justify-space-between" @click="toggle">
                            <div>
                              <div class="font-weight-bold">
                                {{ languageSelect === 0 ? emp.empFull_NameTH : emp.empFull_NameEn }}
                              </div>
                              <div class="text--secondary">
                                {{ emp.empPosition }}
                              </div>
                            </div>
                            <v-icon color="primary">
                              {{ active ? 'mdi-checkbox-marked' : 'mdi-checkbox-blank-outline' }}
                            </v-icon>
                          </div>
                        </v-sheet>
                      </v-item>
                    </v-col>
                  </v-row>
                </v-item-group>
              </div>
              </v-col>
            </v-row>
            <div v-if="formSelect.masBranchID !== '' && formSelect.group_Flow_Id !== '' && formSelect.flowId !== ''">
            <div class="pa-0" v-if="!overlayBulidQueue">
                <div class="pa-0 mb-2 mt-n10">
                <v-row>
                  <v-col cols="2" class="text-center">
                    <v-icon
                      class="mr-n13"
                      v-if="previous"
                      large
                      color="#000000"
                      @click="setMonthCarousel('previous')"
                    >
                      mdi-skip-previous
                    </v-icon>
                  </v-col>
                  <v-col cols="8" class="text-center">
                  <v-menu
                    ref="menupicker"
                    v-model="menu2"
                    :close-on-content-click="false"
                    :nudge-right="-80"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                        <h4
                        class="pa-1 text-center mt-0 font-weight-bold"
                        :style="'color:'+ '#000000' +';'"
                        v-bind="attrs"
                        v-on="on">
                        {{languageSelect === 0 ? defaultMonth.filter((v , k) => (k + 1) === parseInt(momenDate_MM(date)))[0] + ' ' + ' ' + (parseInt(momenDate_YYYY(date)) + 543) : defaultMonthEng.filter((v , k) => (k + 1) === parseInt(momenDate_MM(date)))[0] + ' ' + ' ' + (parseInt(momenDate_YYYY(date))) }}
                        </h4>
                    </template>
                    <v-date-picker
                      v-model="date"
                      type="month"
                      no-title
                      scrollable
                      @input="menu2 = false"
                      :min="currentMonth"
                      :locale="languageSelect === 0 ? 'th': 'sv-se'"
                      @change="setMonthCarousel()"
                    ></v-date-picker>
                  </v-menu>
                  </v-col>
                  <v-col cols="2" class="text-center">
                    <v-icon
                      class="ml-n13"
                      large
                      color="#000000"
                      @click="setMonthCarousel('next')"
                    >
                      mdi-skip-next
                    </v-icon>
                  </v-col>
                </v-row>
              </div>
              <v-slide-group
                v-model="model"
                center-active
                class="pa-4 pt-0 mt-n1"
                color="primary"
              >
                <v-slide-item
                  v-for="(item, n) in queueForMonth"
                  :key="n"
                >
                  <v-card
                    v-if="!item.status_close"
                    :color="item.active ? '#1F6FEB' : '#0D47A1'"
                    :style="'border-radius: 15px 15px 15px 15px;'"
                    class="ma-1 cardBox"
                    height="65px"
                    width="50px"
                    v-on:click="item.active? item.active = false: item.active = true  ,getDetailsVela(item,n)"
                  >
                    <v-row
                      class="fill-height"
                      align="center"
                      justify="center"
                    >
                    <v-col cols="12" class="pa-0 " v-if="languageSelect === 0">
                      <p class="text-center pa-0 ma-0 mt-5 font-weight-bold" :style="'color:#FFFFFF'" >{{item.day_th + '.'}}</p>
                    </v-col>
                    <v-col cols="12" class="pa-0 " v-else>
                      <p class="text-center pa-0 ma-0 mt-5 font-weight-bold" :style="'color:#FFFFFF'" >{{item.day_en + '.'}}</p>
                    </v-col>
                    <v-col cols="12" class="pa-0" >
                      <h4 class="text-center pa-0 ma-0 mt-n1 font-weight-bold" :style="'color:#FFFFFF'" >{{item.day}}</h4>
                    </v-col>
                    </v-row>
                  </v-card>
                  <v-sheet
                    v-else
                    :color="item.active ? '#FFFFFF' : '#FFFFFF'"
                    :style="'border-radius: 15px 15px 15px 15px;'"
                    class="ma-1 cardBox"
                    height="65px"
                    width="50px"
                    readonly
                  >
                    <v-row
                      class="fill-height"
                      align="center"
                      justify="center"
                    >
                    <v-col cols="12" class="pa-0 " v-if="languageSelect === 0">
                      <p class="text-center pa-0 ma-0 mt-5 font-weight-bold" :style="'color:#000000'" >{{item.day_th + '.'}}</p>
                    </v-col>
                    <v-col cols="12" class="pa-0 " v-else>
                      <p class="text-center pa-0 ma-0 mt-5 font-weight-bold" :style="'color:#000000'" >{{item.day_en + '.'}}</p>
                    </v-col>
                    <v-col  cols="12" class="pa-0" >
                      <h4 class="text-center pa-0 ma-0 mt-n1 font-weight-bold"  :style="'color:'+ '#000000'" >{{item.day}}</h4>
                    </v-col>
                    </v-row>
                  </v-sheet>
                </v-slide-item>
              </v-slide-group>
              <v-expand-transition>
                <v-sheet
                  v-if="queueForDateSelect.length > 0"
                  min-height="200"
                  tile
                  class="pa-3 px-5 ml-2 mr-2"
                >
                <v-row>
                  <v-col cols="4" class="pa-0">
                    <h5 class="mt-3 font-weight-bold text-center" >
                      {{languageSelect === 0 ? 'เวลา': 'Time'}}
                    </h5>
                    <div v-for="(item , index) in queueForDateSelect" :key="index">
                      <h5  class="mt-3 font-weight-bold text-center" >
                        <div>
                          <v-sheet
                            class="font-weight-bold text-center"
                            color="#0D47A1"
                            width="100%"
                            height="36px"
                            elevation="2"
                            rounded
                            style="display: flex;justify-content: center;align-items: center;"
                            >
                          <p class="ma-0" style="word-wrap: break-word;color: #FFFFFF;font-size:small;">{{item}}</p>
                          </v-sheet>
                        </div>
                      </h5>
                    </div>
                  </v-col>
                  <v-col cols="4" class="pa-0">
                    <h5 class="mt-3 font-weight-bold text-center" >
                      {{languageSelect === 0 ? 'จำนวนคิว': 'Queues'}}
                    </h5>
                    <div v-for="(item , index) in queueForDateSelect" :key="index">
                      <h5  class="mt-3 font-weight-bold text-center" >
                        <div >
                          <v-btn
                            dark
                            class="font-weight-bold  text-center"
                            color="#0ACF83"
                            width="80%"
                            >{{languageSelect === 0 ? 'ว่าง': 'Ready'}}
                          </v-btn>
                        </div>
                      </h5>
                    </div>
                  </v-col>
                  <v-col cols="4" class="pa-0">
                    <h5 class="mt-3 font-weight-bold text-center" >
                      {{languageSelect === 0 ? 'จองคิว': 'Booking'}}
                    </h5>
                    <div v-for="(item , index) in queueForDateSelect" :key="index">
                      <h5  class="mt-3 font-weight-bold text-center" >
                        <div>
                          <v-btn
                            dark
                            class="font-weight-bold  text-center"
                            color="#0D47A1"
                            width="100%"
                            @click="selectTime(item)"
                            >
                            <v-icon left class="ml-1">
                              mdi-calendar-month
                            </v-icon>
                            {{languageSelect === 0 ? 'นัดหมาย': 'BOOKING'}}
                          </v-btn>
                        </div>
                      </h5>
                    </div>
                  </v-col>
                </v-row>
                </v-sheet>
              </v-expand-transition>
            </div>
            <div class="pa-0" v-else>
              <v-progress-linear
              indeterminate
              color="cyan"
              ></v-progress-linear>
            </div>
            </div>
        </v-card-text>
        <v-card-actions>
          <v-btn
            color="error"
            elevation="2"
            @click="internalDialog = false, depositPrice=0"
          >ยกเลิก</v-btn>
          <v-btn
            color="primary"
            elevation="2"
          >ยืนยัน</v-btn>
        </v-card-actions>
        <DialogPreView
        v-model="showDialogPreView"
        :gallery="prodGallery"
      />
      <FormBooking
      v-model="showDialogCustomField"
      :fieldNameItem="fieldNameItem"
      :flowId="formSelect.flowId"
      :languageSelect="languageSelect"
      :selectedEmpDetailList="selectedEmpDetailList"
      :dueDateSelect="dueDateSelect"
      :dueTimeSelect="dueTimeSelect"
      :groupFlowId="formSelect.group_Flow_Id"
      :groupFlow="groupFlow"
      :DataFlow="DataFlow"
      @update-fieldNameItem="fieldNameItem = $event"
      @update-depositPrice="depositPrice = $event"
      @add-booking="addBooking()"
    />
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from 'axios' // api
import DialogPreView from './DialogPreView.vue'
import FormBooking from './FormBooking.vue'
import moment from 'moment'
export default {
  name: 'DialogAddBooking',
  components: {
    DialogPreView,
    FormBooking
  },
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      languageSelect: 0,
      depositPrice: 0,
      valid: true,
      rules: {
        numberRules: value =>
          (!isNaN(parseFloat(value)) && value >= 0 && value <= 9999999999) ||
          'กรุณากรอกตัวเลข 0 ถึง 9',
        counterTel: value => value.length <= 10 || 'Max 10 characters',
        IDcardRules: value =>
          (!isNaN(parseFloat(value)) && value >= 0 && value <= 9999999999999) ||
          'กรุณากรอกตัวเลข 0 ถึง 9',
        required: value => !!value || 'กรุณากรอก.',
        resizeImag: value =>
          !value ||
          value.size < 2000000 ||
          'Avatar size should be less than 2 MB!',
        counterIDcard: value => value.length <= 13 || 'Max 13 characters',
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'Invalid e-mail.'
        }
      },
      internalDialog: this.value,
      employeeAdminName: [],
      branchData: [],
      branch: [],
      shopId: this.$session.getAll().data.shopId,
      formSelect: {
        group_Flow_Id: '',
        flowId: '',
        empId: '',
        masBranchID: '',
        datemonth: '',
        dateday: ''
      },
      fromAdd: {
        bookingFieldId: null,
        bookingDataCustomerEmail: '',
        fieldId: '',
        fieldValue: '',
        flowId: '',
        masBranchID: '',
        empId: '',
        dueDate: '',
        shopId: '',
        userId: '',
        packageId: '',
        tokenPackage: '',
        statusUpload1: 'False',
        statusUpload2: 'False',
        fileUpload1: '',
        fileUpload2: ''
      },
      groupFlow: [],
      bookingFieldData: [],
      selected: {},
      fieldNameItem: [],
      DataFlow: [],
      DataFlowNameAll: [],
      timeSlot: null,
      empTitleTh: '',
      empTitleEng: '',
      dataEmp: [],
      dataEmpAll: [],
      selectedEmpList: [],
      queueForMonth: [],
      queueForDateSelect: [],
      overlayBulidQueue: false,
      showDialogPreView: false,
      showDialogCustomField: false,
      prodGallery: [],
      dueDateSelect: '',
      dueTimeSelect: '',
      model: 0,
      previous: false,
      currentMonth: moment().format('YYYY-MM'),
      menu2: false,
      date: moment(moment().format('YYYY-MM'), 'YYYY-MM').format('YYYY-MM'),
      dateEng: [{text: 'อา', textEn: 'Sun'}, {text: 'จ', textEn: 'Mon'}, {text: 'อ', textEn: 'Tue'}, {text: 'พ', textEn: 'Wed'}, {text: 'พฤ', textEn: 'Thu'}, {text: 'ศ', textEn: 'Fri'}, {text: 'ส', textEn: 'Sat'}],
      defaultMonth: ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'],
      defaultMonthEng: ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'],
      overlay: false
    }
  },
  watch: {
    value (val) {
      this.internalDialog = val
      if (val) {
        this.clearData()
        this.getDataBranch()
        this.getBookingField()
        this.getGroupFlow()
      }
    },
    internalDialog (val) {
      this.$emit('input', val) // sync กับ parent
    },
    async selectedEmpList (newVal, oldVal) {
      const isDifferent = JSON.stringify(newVal) !== JSON.stringify(oldVal)
      const hasValue = Array.isArray(newVal) && newVal.length > 0
      console.log('newVal', newVal, newVal.length)
      if (newVal.length === 0) {
        this.queueForMonth = []
        this.queueForDateSelect = []
      }
      if (isDifferent && hasValue) {
        const empListLimit = this.DataFlowNameAll.filter((item) => item.flowId === this.formSelect.flowId)[0].empList
        if (newVal.length <= empListLimit) {
          await this.getCalendarQueueVela()
        } else {
          this.selectedEmpList = [...oldVal]
          this.$swal(this.languageSelect === 0 ? `เพิ่มสูงสุดได้ไม่เกิน ${empListLimit} ฉาก` : `You can add up to a maximum of ${empListLimit} scene.`, ' ', 'info')
        }
      }
    }
  },
  computed: {
    selectedEmpDetailList () {
      return this.dataEmpAll.filter(emp =>
        this.selectedEmpList.includes(emp.empId)
      )
    }
  },
  methods: {
    async clearData () {
      this.employeeAdminName = []
      this.branchData = []
      this.branch = []
      this.formSelect = {
        group_Flow_Id: '',
        flowId: '',
        empId: '',
        masBranchID: '',
        datemonth: '',
        dateday: ''
      }
      this.fromAdd = {
        bookingFieldId: null,
        bookingDataCustomerEmail: '',
        fieldId: '',
        fieldValue: '',
        flowId: '',
        masBranchID: '',
        empId: '',
        dueDate: '',
        shopId: '',
        userId: '',
        packageId: '',
        tokenPackage: '',
        statusUpload1: 'False',
        statusUpload2: 'False',
        fileUpload1: '',
        fileUpload2: ''
      }
      this.groupFlow = []
      this.bookingFieldData = []
      this.selected = {}
      this.fieldNameItem = []
      this.DataFlow = []
      this.DataFlowNameAll = []
      this.timeSlot = null
      this.empTitleTh = ''
      this.empTitleEng = ''
      this.dataEmp = []
      this.dataEmpAll = []
      this.selectedEmpList = []
      this.queueForMonth = []
      this.queueForDateSelect = []
      this.overlayBulidQueue = false
      this.prodGallery = []
      this.dueDateSelect = ''
      this.dueTimeSelect = ''
      this.model = 0
      this.depositPrice = 0
      this.menu2 = false
      this.overlay = false
    },
    async openDialogPreView (gallery) {
      this.prodGallery = gallery || []
      if (this.prodGallery.length > 0) {
        this.showDialogPreView = true
      }
    },
    close () {
      this.internalDialog = false
    },
    async getDataBranch () {
      this.branch = []
      this.branchData = []
      await axios.get(this.$DNS_IP + '/master_branch/get?shopId=' + this.shopId).then(response => {
        let rs = response.data
        if (rs.length > 0) {
          for (var i = 0; i < rs.length; i++) {
            let d = rs[i]
            let s = {}
            s.text = d.masBranchName
            s.textEn = d.masBranchNameEn
            s.value = d.masBranchID
            this.branch.push(s)
            this.branchData.push(d)
          }
          if (this.branch.length === 1) {
            this.formSelect.masBranchID = this.branch[0].value
            this.CaseOneBranch()
          }
        }
      })
    },
    async CaseOneBranch () {
      await this.selectBranch()
    },
    async selectBranch () {
      this.formSelect.group_Flow_Id = ''
      await this.getGroupFlow()
    },
    async getGroupFlow () {
      try {
        this.groupFlow = []
        let response = await axios.get(this.$DNS_IP + '/Group_Flow/get?shopId=' + this.shopId)
        for (let index = 0; index < response.data.length; index++) {
          const element = response.data[index]
          if (parseInt(element.masBranchID) === parseInt(this.formSelect.masBranchID)) {
            let s = {}
            s.text = element.groupName
            s.textEng = element.groupNameEn
            s.value = element.group_Flow_Id
            this.groupFlow.push(s)
          }
        }
      } catch (error) {
        console.log('error', error)
      }
    },
    async getBookingField () {
      let itemIncustomField = []
      await axios
        .get(this.$DNS_IP + '/BookingField/get?shopId=' + this.shopId)
        .then(async response => {
          let rs = response.data
          if (rs.length > 0) {
            this.fromAdd.bookingFieldId = rs[0].bookingFieldId
            this.bookingFieldData = rs
            let bookingData = []
            bookingData = JSON.parse(rs[0].flowfieldNameCustomer)
            for (let i = 0; i < bookingData.length; i++) {
              let d = bookingData[i]
              itemIncustomField.push(d.fieldId)
            }
            await this.getCustomField(itemIncustomField)
          } else {
            this.$swal(
              this.languageSelect === 0 ? 'พบความผิดพลาดระหว่างดำเนินการ' : 'An error was encountered during the operation.',
              this.languageSelect === 0 ? 'กรุณากดปุ่มเพื่อดึงข้อมูลใหม่' : 'Please press the button to fetch new data.',
              'info'
            ).then(result => {
              this.internalDialog = false
            }).catch(error => {
              console.log('error function addData : ', error)
              this.internalDialog = false
            })
          }
        }).catch(error => {
          this.$swal(
            this.languageSelect === 0 ? 'พบความผิดพลาดระหว่างดำเนินการ' : 'An error was encountered during the operation.',
            this.languageSelect === 0 ? 'กรุณากดปุ่มเพื่อดึงข้อมูลใหม่' : 'Please press the button to fetch new data.',
            'info'
          )
            .then(result => {
              this.internalDialog = false
            })
            .catch(error => {
              console.log('error function addData : ', error)
              this.internalDialog = false
            })
          console.log('error function addData : ', error)
        })
    },
    async getCustomField (item) {
      this.fieldNameItem = []
      await axios
        .get(this.$DNS_IP + '/customField/fieldId?fieldId=' + item)
        .then(async response => {
          let rs = response.data
          if (rs.length > 0) {
            let sortNo = rs.sort((a, b) => a.sortNoField - b.sortNoField)
            for (let i = 0; i < sortNo.length; i++) {
              let d = sortNo[i]
              let s = {}
              s.fieldId = d.fieldId
              s.fieldName = d.fieldName
              s.fieldNameEn = d.fieldNameEn
              s.fieldType = d.fieldType
              if (d.fieldType === 'Checkbox') {
                this.selected[s.fieldId] = []
              }
              s.optionField = d.optionField
              s.conditionField = d.conditionField
              s.conditionValue = d.conditionValue
              s.shopId = d.shopId
              s.fieldValue = s.fieldType === 'Checkbox' ? '[]' : ''
              s.requiredField = d.requiredField
              this.fieldNameItem.push(s)
            }
            let data1 = this.fieldNameItem.filter(
              el => parseInt(el.conditionField || 0) > 0
            )
            for (let i = 0; i < data1.length; i++) {
              let d = data1[i]
              let indexC = this.fieldNameItem.findIndex(function (o) {
                return o.fieldId === d.fieldId
              })
              let indexF = this.fieldNameItem.findIndex(function (o) {
                return o.fieldId === parseInt(d.conditionField)
              })
              this.fieldNameItem.splice(
                indexF + 1,
                0,
                this.fieldNameItem.splice(indexC, 1)[0]
              )
            }
          } else {
            this.$swal(
              this.languageSelect === 0 ? 'พบความผิดพลาดระหว่างดำเนินการ' : 'An error was encountered during the operation.',
              this.languageSelect === 0 ? 'กรุณากดปุ่มเพื่อดึงข้อมูลใหม่' : 'Please press the button to fetch new data.',
              'info'
            )
              .then(result => {
                this.internalDialog = false
              })
              .catch(error => {
                console.log('error function addData : ', error)
                this.internalDialog = false
              })
          }
        })
        .catch(error => {
          this.$swal(
            this.languageSelect === 0 ? 'พบความผิดพลาดระหว่างดำเนินการ' : 'An error was encountered during the operation.',
            this.languageSelect === 0 ? 'กรุณากดปุ่มเพื่อดึงข้อมูลใหม่' : 'Please press the button to fetch new data.',
            'info'
          )
            .then(result => {
              this.internalDialog = false
            })
            .catch(error => {
              console.log('error function addData : ', error)
              this.internalDialog = false
            })
          console.log('error function addData : ', error)
        })
    },
    async selectGroupFlow () {
      this.formSelect.flowId = ''
      this.dateSelect = []
      await this.getDataFlow()
    },
    async getDataFlow () {
      this.DataFlowNameAll = []
      this.DataFlow = []
      let dataFlow = []
      let dataFlowName = []
      let dataFlowNameAll = []
      // console.log('DataFlowName', this.DataFlowName)
      await axios.get(this.$DNS_IP + '/flow/get?shopId=' + this.shopId).then(response => {
        let rs = response.data
        if (rs.length > 0) {
          for (var i = 0; i < rs.length; i++) {
            let d = rs[i]
            let checkBranchByFlow = d.masBranchID || 'All'
            if ((checkBranchByFlow === this.formSelect.masBranchID.toString()) || checkBranchByFlow === 'All') {
              if (d.group_Flow_Id === this.formSelect.group_Flow_Id) {
                if (this.StatusChecknewCustome === true) {
                  if (d.newCustomerStatus === 'True') {
                    d.text = d.flowName
                    d.textEn = d.flowNameEn
                    d.value = d.flowId
                    dataFlowName.push(d)
                    dataFlowNameAll.push(d)
                    dataFlow.push(d)
                  }
                } else {
                  d.text = d.flowName
                  d.textEn = d.flowNameEn
                  d.value = d.flowId
                  dataFlowName.push(d)
                  dataFlowNameAll.push(d)
                  dataFlow.push(d)
                }
              }
            }
          }
          this.DataFlowNameAll = dataFlowNameAll
          this.DataFlow = dataFlow
        } else {
          this.DataFlow = []
          this.DataFlowNameAll = []
        }
      })
    },
    async checkBranch (defaultEmp = '') {
      let dataFlowFilter = this.DataFlowNameAll.filter((item) => item.flowId === this.formSelect.flowId)
      try {
        if (this.formSelect.masBranchID !== '') {
          this.timeSlot = dataFlowFilter[0].timeSlot
          this.formSelect.empId = defaultEmp
          await this.getEmp()
        }
      } catch (err) {
        if (this.formSelect.masBranchID !== '') {
          this.timeSlot = dataFlowFilter[0].timeSlot
          this.formSelect.empId = defaultEmp
          await this.getEmp()
        }
      }
    },
    checkTitleEmp () {
      let checkDataEmpTitle = this.DataFlowNameAll.filter(el => { return el.flowId === this.formSelect.flowId })
      if (checkDataEmpTitle.length > 0) {
        this.empTitleTh = checkDataEmpTitle[0].empTitleTh || 'พนักงานช่าง'
        this.empTitleEng = checkDataEmpTitle[0].empTitleEng || 'Employee'
      } else {
        this.empTitleTh = 'พนักงานช่าง'
        this.empTitleEng = 'Employee'
      }
    },
    async resetData () {
      await this.$emit('resetData')
      this.internalDialog = false
    },
    async getEmp () {
      this.dataEmp = []
      this.dataEmpAll = []
      await axios.get(this.$DNS_IP + '/empSelect/get?privacyPage=bookingform&masBranchID=' + this.formSelect.masBranchID).then(response => {
        let rs = response.data
        if (rs.length > 0) {
          for (var i = 0; i < rs.length; i++) {
            let d = rs[i]
            if (d.flowId !== null && d.flowId !== '') {
              let checkFlowId = JSON.parse(d.flowId)
              if (checkFlowId.filter((a) => parseInt(a) === this.formSelect.flowId).length > 0) {
                if (d.setTime !== null && d.setTime !== '[]' && d.setTime !== '') {
                  let s = {}
                  s.text = d.empFull_NameTH
                  s.textEng = d.empFull_NameTH
                  s.value = d.empId
                  s.creditpackage = d.credit_package
                  this.dataEmp.push(s)
                  d.picture = JSON.parse(d.pictureList) || []
                  this.dataEmpAll.push(d)
                }
              }
            }
          }
          if (this.dataEmp.length === 0) {
            this.$swal(
              this.languageSelect === 0 ? 'ไม่มี' + this.empTitleTh + 'สำหรับประเภทบริการนี้' : 'There is no ' + this.empTitleEng + ' for this type of service.',
              this.languageSelect === 0 ? 'กรุณาเลือกประเภทบริการอื่นๆ' : 'Please select another type of service.',
              'info'
            )
          }
        } else {
          this.dataEmp = []
          this.dataEmpAll = []
        }
      })
    },
    async getCalendarQueueVela () {
      const payload = {
        'dateMonth': this.date,
        'timeSlot': this.timeSlot,
        'empId': this.selectedEmpList
      }
      this.overlayBulidQueue = true
      try {
        const result = await axios.post(this.$DNS_IP + '/employee_vela/get_calendar_queue', payload)
        if (result.data.status) {
          this.queueForMonth = result.data.message
          await this.defaultDetailsVela()
        } else {
          this.queueForMonth = []
        }
      } catch (error) {
        this.queueForMonth = []
      } finally {
        this.overlayBulidQueue = false
      }
    },
    async defaultDetailsVela () {
      for (let index = 0; index < this.queueForMonth.length; index++) {
        const element = this.queueForMonth[index]
        if (element.active) {
          this.getDetailsVela(element, index)
        }
      }
    },
    async getDetailsVela (item, key) {
      this.queueForDateSelect = []
      this.dueDateSelect = ''
      this.queueForMonth.forEach((i, u) => {
        if (u !== key) {
          i.active = false
        } else {
          this.dueDateSelect = i.date
        }
      })
      let filterSelect = this.queueForMonth.filter((item) => item.active === true)
      if (filterSelect.length > 0) {
        this.queueForDateSelect = filterSelect[0].available_time
      } else {
        this.queueForDateSelect = []
      }
      this.model = key
    },
    async setMonthCarousel (item) {
      // console.log('//////////////////////////', moment(this.date, 'YYYY-MM').format('YYYY-MM'))
      // console.log('currentMonth', moment(this.currentMonth, 'YYYY-MM').format('YYYY-MM'))
      if (item === 'next') {
        this.date = moment(this.date).add(1, 'months').format('YYYY-MM')
      } else if (item === 'next_bookingNowCheckCount_month') {
        this.date = moment(this.date).add(1, 'months').format('YYYY-MM')
      } else if (item === 'previous') {
        this.date = moment(this.date).add(-1, 'months').format('YYYY-MM')
      } else {

      }
      if (moment(this.date, 'YYYY-MM').format('YYYY-MM') > moment(this.currentMonth, 'YYYY-MM').format('YYYY-MM')) {
        if (this.next_bookingNowCheckCount_month === 'False') {
          this.previous = true
        }
      } else {
        this.previous = false
      }
      await this.getCalendarQueueVela()
    },
    async selectTime (time) {
      this.dueTimeSelect = time
      await this.openDialogCustomField()
    },
    async openDialogCustomField () {
      this.showDialogCustomField = true
    },
    async addBooking () {
      let statusLimitFull = await this.checkLimitBooking()
      if (statusLimitFull) {
        await this.addBookingsubmit()
      }
    },
    async checkLimitBooking () {
      try {
        const payload = {
          'dateDay': this.dueDateSelect,
          'dateTime': this.dueTimeSelect,
          'timeSlot': this.timeSlot,
          'empId': this.selectedEmpList
        }
        const response = await axios.post(this.$DNS_IP + '/employee_vela/check_limit_by_date', payload)
        console.log('response', response.data)
        if (response.data.status) {
          if (response.data.limit_full) {
            this.$swal(
              this.languageSelect === 0 ? 'มีลูกค้าท่านอื่นนัดหมายเวลานี้แล้ว' : 'There are other customers making appointments at this time.',
              this.languageSelect === 0 ? 'กรุณาเลือกวันที่ / เวลา ใหม่อีกครั้ง' : 'Please select a new date/time again.',
              'info'
            )
            return false
          } else {
            return true
          }
        } else {
          this.$swal(
            this.languageSelect === 0 ? 'พบความผิดพลาดระหว่างดำเนินการ' : 'An error was encountered during the operation.',
            this.languageSelect === 0 ? 'กรุณากดปุ่มเพื่อดึงข้อมูลใหม่' : 'Please press the button to fetch new data.',
            'info'
          )
            .then(result => {
              this.internalDialog = false
            })
            .catch(error => {
              console.log('error function addData : ', error)
              this.internalDialog = false
            })
          return false
        }
      } catch (error) {
        console.log('error', error)
        return false
      }
    },
    async addBookingsubmit () {
      let rs = this.fieldNameItem
      let Add = []
      let fielditem = this.fieldNameItem
      let dueDate = this.dueDateSelect + ' ' + this.dueTimeSelect
      let userId = 'user-skip'
      for (let i = 0; i < rs.length; i++) {
        let d = rs[i]
        let update = {}
        if (d.conditionField === '' || d.conditionField === null) {
          update.masBranchID = this.formSelect.masBranchID
          update.bookingFieldId = this.fromAdd.bookingFieldId
          update.flowId = this.formSelect.flowId
          update.empId = this.fromAdd.empId
          update.bookingEmpArray = JSON.stringify(this.selectedEmpList)
          update.timeSlot = this.timeSlot
          update.fieldId = d.fieldId
          update.fieldName = d.fieldName
          update.fieldValue = d.fieldValue.replace(/\\/g, '\\\\').replace(/%/g, '%%').replace(/'/g, "\\'")
          update.shopId = d.shopId
          update.dueDate = dueDate
          update.timeText = this.dueTimeSelect
          update.userId = userId
          update.CREATE_USER = this.$session.getAll().data.userName
          update.LAST_USER = this.$session.getAll().data.userName
          update.dateSelect = this.dueDateSelect
          update.timeSelect = this.dueTimeSelect
          update.bookingLanguage = this.languageSelect
          update.depositPrice = this.depositPrice
          update.IsNotify = 'False'
          Add.push(update)
        } else {
          if (fielditem.filter(row => {
            return row.fieldId === parseInt(d.conditionField)
          }).length > 0
          ) {
            if (
              d.conditionValue ===
              fielditem.filter(row => {
                return row.fieldId === parseInt(d.conditionField)
              })[0].fieldValue
            ) {
              update.masBranchID = this.formSelect.masBranchID
              update.bookingFieldId = this.fromAdd.bookingFieldId
              update.flowId = this.formSelect.flowId
              update.empId = this.fromAdd.empId
              update.bookingEmpArray = JSON.stringify(this.selectedEmpList)
              update.timeSlot = this.timeSlot
              update.fieldId = d.fieldId
              update.fieldName = d.fieldName
              update.fieldValue = d.fieldValue.replace(/\\/g, '\\\\').replace(/%/g, '%%').replace(/'/g, "\\'")
              update.shopId = d.shopId
              update.dueDate = dueDate
              update.timeText = this.dueTimeSelect
              update.userId = userId
              update.CREATE_USER = this.$session.getAll().data.userName
              update.LAST_USER = this.$session.getAll().data.userName
              update.dateSelect = this.dueDateSelect
              update.timeSelect = this.dueTimeSelect
              update.bookingLanguage = this.languageSelect
              update.depositPrice = this.depositPrice
              update.IsNotify = 'False'
              Add.push(update)
            }
          } else if (d.conditionField === 'flow') {
            if (parseInt(d.conditionValue) === parseInt(this.fromAdd.flowId)) {
              update.masBranchID = this.formSelect.masBranchID
              update.bookingFieldId = this.fromAdd.bookingFieldId
              update.flowId = this.formSelect.flowId
              update.empId = this.fromAdd.empId
              update.bookingEmpArray = JSON.stringify(this.selectedEmpList)
              update.timeSlot = this.timeSlot
              update.fieldId = d.fieldId
              update.fieldName = d.fieldName
              update.fieldValue = d.fieldValue.replace(/\\/g, '\\\\').replace(/%/g, '%%').replace(/'/g, "\\'")
              update.shopId = d.shopId
              update.dueDate = dueDate
              update.timeText = this.dueTimeSelect
              update.userId = userId
              update.CREATE_USER = this.$session.getAll().data.userName
              update.LAST_USER = this.$session.getAll().data.userName
              update.dateSelect = this.dueDateSelect
              update.timeSelect = this.dueTimeSelect
              update.bookingLanguage = this.languageSelect
              update.depositPrice = this.depositPrice
              update.IsNotify = 'False'
              Add.push(update)
            }
          }
        }
      }
      console.log('Add', Add)
      this.$swal({
        title: this.languageSelect === 0 ? 'ยืนยันรายการนัดหมาย' : 'Please confirm your booking',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: this.languageSelect === 0 ? 'ใช่' : 'Yes',
        cancelButtonText: this.languageSelect === 0 ? 'ไม่' : 'No'
      })
        .then(async result => {
          this.overlay = true
          axios
            .post(this.$DNS_IP + '/employee_vela/abb_booking', Add)
            .then(async response => {
              if (response.data.message === 'LimitBooking_Full') {
                this.$swal(this.languageSelect === 0 ? 'คิวเต็มแล้ว' : 'Full queue', this.languageSelect === 0 ? 'กรุณาเลือกวันที่ใหม่อีกครั้ง' : 'Please select a new date again.', 'error')
                this.overlay = false
              } else {
                // let bookNo = response.data.bookNo
                // let dtt = {
                //   bookNo: bookNo,
                //   contactDate: moment().format('YYYY-MM-DD HH:mm'),
                //   status: 'confirm',
                //   statusUse: 'use',
                //   shopId: this.shopId,
                //   CREATE_USER: userId,
                //   LAST_USER: userId
                // }
                // await axios
                //   .post(this.$DNS_IP + '/booking_transaction/add', dtt)
                //   .then(async response => {
                //     // if (this.statusGoogleCalendar === 'True') {
                //     //   this.connectGoogleCalendar(dtt.shopId, 'Add', dtt.bookNo)
                //     // }
                //   }).catch(error => {
                //     console.log('error function booking_transaction : ', error)
                //   })
                this.$swal(
                  'เรียบร้อย',
                  'เพิ่มรายการนัดหมาย เรียบร้อย',
                  'success'
                )
                this.resetData()
              }
            })
            .catch(error => {
              this.overlay = false
              console.log('error function addData : ', error)
            })
        })
        .catch(error => {
          this.overlay = false
          console.log('Cencel : ', error)
        })
    }
  }
}
</script>
<style scoped>
.InputData {
  margin: 0px !important;
  padding: 0px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/VelaStudio/DialogAddBooking.vue